export default __webpack_public_path__ + "81d0ae0c15333948a37d3ddc5fe65318.ttf";